import { FormsModule } from '@angular/forms';
import { ProductoSelectBusquedaModule } from './../producto-select-busqueda/producto-select-busqueda.module';
import { NgbDatepickerModule, NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { FiltroMagicoComponent } from './filtro-magico.component';
import { NgModule } from '@angular/core';
import { NgModelChangeDebounceDirective } from './directives/ng-model-change-debounce.directive';
import { SelectSearchMultipleComponent } from './components/select-search-multiple/select-search-multiple.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgbModule,
    NgbPaginationModule,
    NgbDatepickerModule,
   // ProductoSelectBusquedaModule,
  ],
  exports: [
    FiltroMagicoComponent
  ],
  declarations: [
    FiltroMagicoComponent,
    NgModelChangeDebounceDirective,
    SelectSearchMultipleComponent,
  ],
  bootstrap:[],
})
export class FiltroMagicoModule { }
